import { useState } from 'react';
import { Button, CircularProgress } from '@mui/material';
import { Refresh } from '@mui/icons-material';
import { useQueryClient } from '@tanstack/react-query';
import { useSnackbar } from 'notistack';
import { activityService } from '../services/activity.service';

export default function RefreshActivityButton({ invalidateKeys }: { invalidateKeys: string[] }) {
  const [refreshing, setRefreshing] = useState(false);
  const queryClient = useQueryClient();
  const { enqueueSnackbar } = useSnackbar();

  const run = async () => {
    setRefreshing(true);
    try {
      await activityService.refresh();
      invalidateKeys.forEach((key) => queryClient.invalidateQueries({ queryKey: [key] }));
      enqueueSnackbar('Activity refreshed', { variant: 'success' });
    } catch (e) {
      enqueueSnackbar(e instanceof Error ? e.message : 'Refresh failed', { variant: 'error' });
    } finally {
      setRefreshing(false);
    }
  };

  return (
    <Button
      variant="outlined"
      startIcon={refreshing ? <CircularProgress size={16} /> : <Refresh />}
      disabled={refreshing}
      onClick={run}
    >
      {refreshing ? 'Refreshing…' : 'Refresh activity'}
    </Button>
  );
}
